import { render } from "./StartNewActivity.vue?vue&type=template&id=4cae3180&lang=true"
import script from "./StartNewActivity.vue?vue&type=script&lang=js"
export * from "./StartNewActivity.vue?vue&type=script&lang=js"

import "./StartNewActivity.vue?vue&type=style&index=0&id=4cae3180&lang=scss"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__